<template>
  <div>
    <v-card class="sf-card"
            flat>
      <div class="sf-card__header">
        <h2 class="sf-card__title">{{ $t('customer') }}</h2>
      </div>
      <v-card-text class="sf-card__body">
        <v-form ref="form">
          <v-row class="sf-form-row">
            <v-col cols="12" sm="4">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:disabled="editMode"
                            v-bind:label="$t('customerNumber')"
                            v-bind:rules="[ rules.required ]"
                            v-model="customer.id" />
            </v-col>
            <v-col cols="12" sm="8">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('companyName')"
                            v-bind:rules="[ rules.required ]"
                            v-model="customer.companyName" />
            </v-col>
          </v-row>

          <h3 class="sf-section-title mt-6">{{ $t('contact') }}</h3>
          <v-row class="sf-form-row">
            <v-col cols="12" sm="4">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('salutation')"
                            v-model="customer.salutation" />
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('givenName')"
                            v-model="customer.givenName" />
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('familyName')"
                            v-model="customer.familyName" />
            </v-col>
            <v-col cols="12">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('email')"
                            v-bind:rules="[ rules.required ]"
                            v-model="customer.email" />
            </v-col>
          </v-row>

          <h3 class="sf-section-title mt-6">{{ $t('address') }}</h3>
          <v-row class="sf-form-row">
            <v-col cols="12">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('streetAddress')"
                            v-bind:rules="[ rules.required ]"
                            v-model="customer.streetAddress" />
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('postalCode')"
                            v-bind:rules="[ rules.required ]"
                            v-model="customer.postalCode" />
            </v-col>
            <v-col cols="12" sm="8">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('city')"
                            v-bind:rules="[ rules.required ]"
                            v-model="customer.city" />
            </v-col>
          </v-row>

          <h3 class="sf-section-title mt-6">{{ $t('classification') }}</h3>
          <v-row class="sf-form-row">
            <v-col cols="12" sm="6">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('group')"
                            v-model="customer.group" />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('color')"
                            v-model="customer.color" />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('orderType')"
                            v-model="customer.orderType" />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('fieldSalesRep')"
                            v-model="customer.fieldSalesRep" />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  export default {
    computed: {
      rules() {
        return {
          required: v => !!v || this.$t('form.required')
        }
      }
    },
    methods: {
      validate() {
        return this.$refs.form.validate()
      }
    },
    name: 'CustomerEditCard',
    props: {
      customer: Object,
      editMode: Boolean
    }
  }
</script>

<i18n>
  {
    "de": {
      "city": "Stadt",
      "color": "Farbe",
      "companyName": "Firmenname",
      "customer": "Kunde",
      "customerNumber": "Kundennummer",
      "email": "E-Mail-Adresse",
      "givenName": "Vorname",
      "group": "Gruppe",
      "familyName": "Nachname",
      "postalCode": "Postleitzahl",
      "salutation": "Anrede",
      "streetAddress": "Adresse",
      "orderType": "Ordersatz",
      "fieldSalesRep": "Außendienstmitarbeiter",
      "contact": "Kontakt",
      "address": "Adresse",
      "classification": "Zuordnung"
    },
    "en": {
      "city": "City",
      "color": "Color",
      "companyName": "Company name",
      "customer": "Customer",
      "customerNumber": "Customer number",
      "email": "Email",
      "givenName": "Given name",
      "group": "Group",
      "familyName": "Family name",
      "postalCode": "Postal code",
      "salutation": "Salutation",
      "streetAddress": "Street address",
      "orderType": "Order type",
      "fieldSalesRep": "Field sales representative",
      "contact": "Contact",
      "address": "Address",
      "classification": "Classification"
    }
  }
</i18n>